import { render, staticRenderFns } from "./aktivitasmrj.vue?vue&type=template&id=82370a18"
import script from "./aktivitasmrj.vue?vue&type=script&lang=js"
export * from "./aktivitasmrj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports